import * as actionTypes from "../constants/actionTypes";

function getSortFromInitialSort(clientConfig, offerType) {
  switch (offerType) {
    case "phoneOffer":
      return clientConfig.widgetOptions.phoneOffer.initialSort;
    case "proposition":
      return clientConfig.widgetOptions.proposition.initialSort;
    case "simOnly":
      return clientConfig.widgetOptions.simOnly.initialSort;
    default:
      return {};
  }
}

const resetSort = (offerType, clientConfig) => {
  const sort = getSortFromInitialSort(clientConfig, offerType);

  return {
    type: actionTypes.RESET_SORT,
    offerType: offerType,
    sort: sort
  };
};

const resetSorts = clientConfig => {
  const phoneOfferSort = getSortFromInitialSort(clientConfig, "phoneOffer");
  const propositionSort = getSortFromInitialSort(clientConfig, "proposition");
  const simOnlySort = getSortFromInitialSort(clientConfig, "simOnly");
  const sort = {
    phoneOffer: phoneOfferSort,
    proposition: propositionSort,
    simOnly: simOnlySort
  };

  return {
    type: actionTypes.RESET_SORTS,
    sort: sort
  };
};

const updateSort = (offerType, sort) => {
  return {
    type: actionTypes.UPDATE_SORT,
    offerType: offerType,
    sort: sort
  };
};

export { resetSort, resetSorts, updateSort };
